export const routes = {
    code: "/code",
    forgotPassword: "/forgot-password",
    login: "/login",
    profile: "/profile",
    register: "/register",
    resetPassword: "/reset-password",
    result: "/result",
    root: "/",
} as const;
